(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["related-categories"] && !Shopify.designMode) return;
  try {
    
  function docReady(fn) {
    // see if DOM is already available
    if (document.readyState === 'complete' || document.readyState === 'interactive') {
      // call on next available tick
      setTimeout(fn, 1);
    } else {
      document.addEventListener('DOMContentLoaded', fn);
    }
  }

  docReady(function () {
    // console.log('ready!')
    const relatedCategoriesDiv = document.querySelector('#catSection');
    const relatedCatContainer = document.querySelector('#relatedCatContainer');
    console.log(jsonRelatedProducts);
    let fragment = document.createDocumentFragment();

    if(Object.keys(jsonRelatedProducts).length > 0) {

      const arrayName = Object.keys(jsonRelatedProducts)[0];

      jsonRelatedProducts[arrayName].sort((a, b) => {
        const titleA = a.title.toLowerCase();
        const titleB = b.title.toLowerCase();
      
        if (titleA < titleB) {
          return -1;
        } else if (titleA > titleB) {
          return 1;
        }
      
        return 0;
      });
      
      for (var value in jsonRelatedProducts) {
        if (jsonRelatedProducts !== null && jsonRelatedProducts[value].length > 0) {
          for (var keyPairValue of jsonRelatedProducts[value]) {
            console.log(keyPairValue);
            let gridItem = document.createElement('div');
            gridItem.setAttribute('class', 'grid-item');
            
            
            let collectionItem = document.createElement('a');
            collectionItem.setAttribute('href', keyPairValue.handle);
            collectionItem.setAttribute('class', 'collection-item');
            
            let collectionImageWrap = document.createElement('div');
            collectionImageWrap.setAttribute('id', keyPairValue.id);
            collectionImageWrap.setAttribute('class', 'collection-image-wrap collection-image--square');
            
            let collectionImage = document.createElement('div');
            collectionImage.setAttribute('class', 'collection-image image-wrap loaded');
            
            
            let catTitle = document.createElement('span');
            catTitle.setAttribute('class', 'collection-item__title');
            catTitle.textContent = keyPairValue.title;
            
            let imgElementWrapper = document.createElement('image-element');
            imgElementWrapper.setAttribute('data-aos', 'image-fade-in');
            imgElementWrapper.setAttribute('class', 'aos-init aos-animate');
            console.log(keyPairValue.imgUrl)
            let catImg = document.createElement('img');
            let imgUrl = keyPairValue.imgUrl ? keyPairValue.imgUrl
              : keyPairValue.ImageUrl ? keyPairValue.ImageUrl
              : 'https://cdn.shopify.com/s/files/1/0565/0720/3649/files/img-not-found.png';
            catImg.setAttribute('src', imgUrl);
            catImg.setAttribute('class', 'image-element');


            gridItem.appendChild(collectionItem);
            collectionItem.appendChild(collectionImageWrap);
            collectionItem.appendChild(catTitle);

            collectionImageWrap.appendChild(collectionImage);
            collectionImage.appendChild(imgElementWrapper);
            imgElementWrapper.appendChild(catImg);
            
            fragment.appendChild(gridItem);
            
          }
        } else {
          relatedCatContainer.style.display = "none";
        }
      }
    } else {
      relatedCatContainer.style.display = "none";
    }
    
    relatedCategoriesDiv.append(fragment);
  });

  } catch(e) { console.error(e); }
})();
})();
